import React, {useCallback, useRef, useState} from 'react';
import SectionPopup from './SectionPopup.js';
import PopupSearch from './PopupSearch.js';
import PaymentList from './PaymentList.js';
import usePopupSearch from '../utils/usePopupSearch.js';

// Popup s platbami konkrétního uživatele (monitoring). Obsah je stejný jako
// v sekci /payment (sdílená komponenta PaymentList), hledání se předvyplní
// jménem uživatele a jde libovolně přepsat.
export default function UserPaymentsPopup({show, close, user, usrInfo, onNavigate}) {
	const [loading, setLoading] = useState(false);
	const listRef = useRef(null);
	const userSearch = `${user?.LASTNAME || ''} ${user?.FIRSTNAME || ''}`.trim();
	const userName = user?.NAME || userSearch;
	const {searchInput, search, onChangeSearch, setSearchNow} = usePopupSearch(show, userSearch);

	const handleLoadingChange = useCallback((isLoading) => {
		setLoading(isLoading);
	}, []);

	const toolbar = (
		<>
			<PopupSearch searchValue={searchInput} onChangeSearch={onChangeSearch} placeholder="Vyhledat v platbách" />
			{usrInfo?.sysAdmin === 1 ? (
				<button type="button" className="button small" onClick={() => listRef.current?.openNew()}>
					Nový
				</button>
			) : null}
		</>
	);

	return (
		<SectionPopup show={show} close={close} title={`Platby${userName !== '' ? ` – ${userName}` : ''}`} toolbar={toolbar} loading={loading} className="user-payments-popup" onNavigate={onNavigate}>
			<div className="payment-page payment-page--popup">
				<PaymentList ref={listRef} usrInfo={usrInfo} searchValue={search} onChangeSearch={setSearchNow} onLoadingChange={handleLoadingChange} />
			</div>
		</SectionPopup>
	);
}
